import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c39fb8ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<svg width=\"380px\" height=\"500px\" viewBox=\"0 0 837 1045\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" data-v-c39fb8ac><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" data-v-c39fb8ac><path id=\"Polygon-1\" d=\"M353,9 L626.664028,170 L626.664028,487 L353,642 L79.3359724,487 L79.3359724,170 L353,9 Z\" stroke=\"#007FB2\" stroke-width=\"6\" data-v-c39fb8ac></path><path id=\"Polygon-2\" d=\"M78.5,529 L147,569.186414 L147,648.311216 L78.5,687 L10,648.311216 L10,569.186414 L78.5,529 Z\" stroke=\"#EF4A5B\" stroke-width=\"6\" data-v-c39fb8ac></path><path id=\"Polygon-3\" d=\"M773,186 L827,217.538705 L827,279.636651 L773,310 L719,279.636651 L719,217.538705 L773,186 Z\" stroke=\"#795D9C\" stroke-width=\"6\" data-v-c39fb8ac></path><path id=\"Polygon-4\" d=\"M639,529 L773,607.846761 L773,763.091627 L639,839 L505,763.091627 L505,607.846761 L639,529 Z\" stroke=\"#F2773F\" stroke-width=\"6\" data-v-c39fb8ac></path><path id=\"Polygon-5\" d=\"M281,801 L383,861.025276 L383,979.21169 L281,1037 L179,979.21169 L179,861.025276 L281,801 Z\" stroke=\"#36B455\" stroke-width=\"6\" data-v-c39fb8ac></path></g></svg>", 1)
const _hoisted_2 = { class: "message-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "404", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "找不到页面", -1))
const _hoisted_5 = { class: "buttons-con" }
const _hoisted_6 = { class: "action-link-wrap" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 返回上一页 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 返回首页 ")

export function render(_ctx: any,_cache: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.clickBack
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.clickHome
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}